
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./vue-apollo-6-more-mutations-and-updating-the-store.json") })
        }
      }, "path---vue-apollo-6-more-mutations-and-updating-the-store");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---vue-apollo-6-more-mutations-and-updating-the-store!./.cache/json/vue-apollo-6-more-mutations-and-updating-the-store.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---vue-apollo-6-more-mutations-and-updating-the-store!./.cache/json/vue-apollo-6-more-mutations-and-updating-the-store.json
// module chunks = 154